// extracted by mini-css-extract-plugin
export var animationContainer = "_hi-0";
export var asteriskIcon = "_hi-8";
export var conversationLeftSection = "_hi-4";
export var conversationListItem = "_hi-3";
export var conversationMiddleSection = "_hi-5";
export var conversationRightSection = "_hi-6";
export var detailsContent = "_hi-1";
export var listContainer = "_hi-7";
export var modalContent = "_hi-2";